module.exports = __webpack_public_path__ + "img/nodejs.c4922fc9.png";